/**
 * @file MultiTenantHomePage.js
 * @description Multi-tenant portal home page.
 */

import MultiTenantDashboardPage from '../dashboard/MultiTenantDashboardPage';

function MultiTenantHomePage() {
    return <MultiTenantDashboardPage />;
}

export default MultiTenantHomePage;
